import { customerAddressFormFieldStyles } from "@insite/content-library/Components/CustomerAddressFormFields";
import { formGridProps } from "@store/theme/props/form";

Object.assign(customerAddressFormFieldStyles, {
    container: formGridProps,
    firstNameGridItem: { width: [12, 12, 12, 6, 6] },
    lastNameGridItem: { width: [12, 12, 12, 6, 6] },
    companyNameGridItem: { width: [12, 12, 12, 6, 6] },
    attentionGridItem: { width: [12, 12, 12, 6, 6] },
    stateGridItem: { width: [12, 12, 12, 6, 6] },
    postalCodeGridItem: { width: [12, 12, 12, 6, 6] },
    phoneGridItem: { width: [12, 12, 12, 6, 6] },
    faxGridItem: { width: [12, 12, 12, 6, 6] },
});
